export const PICKUP_LOCATION =
  "Cofetăria Ahava – Strada Elena Ghiba Birta 6-8, Arad";

const PROGRAM = {
  1: { startHour: 8, endHour: 20 }, // Luni
  2: { startHour: 8, endHour: 20 }, // Marți
  3: { startHour: 8, endHour: 20 }, // Miercuri
  4: { startHour: 8, endHour: 20 }, // Joi
  5: { startHour: 8, endHour: 20 }, // Vineri
  6: { startHour: 8, endHour: 19 }, // Sâmbătă
  0: { startHour: 9, endHour: 19 }, // Duminică
};

export function getMaxPreparationHours(items) {
  return items.reduce(
    (max, item) => Math.max(max, Number(item.termen_ore || 0)),
    0,
  );
}

export function getEarliestPickupDateTime(items) {
  const now = new Date();
  const maxHours = getMaxPreparationHours(items);
  return new Date(now.getTime() + maxHours * 60 * 60 * 1000);
}

export function formatDateInputValue(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function addDays(date, days) {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

function getDateFromInput(dateStr) {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
}

function formatHour(hour) {
  return `${String(hour).padStart(2, "0")}:00`;
}

export function getAvailableSlotsForDate(selectedDateStr, items) {
  if (!selectedDateStr) return [];

  const earliest = getEarliestPickupDateTime(items);
  const selectedDate = getDateFromInput(selectedDateStr);

  const day = selectedDate.getDay();
  const program = PROGRAM[day];

  if (!program) return [];

  const slots = [];

  for (let hour = program.startHour; hour < program.endHour; hour++) {
    const slotDate = new Date(selectedDate);
    slotDate.setHours(hour, 0, 0, 0);

    if (slotDate >= earliest) {
      const value = formatHour(hour);

      slots.push({
        value,
        startHour: hour,
        endHour: hour + 1,
      });
    }
  }

  return slots;
}

export function getFirstAvailablePickupOption(items, maxDaysToCheck = 30) {
  const earliest = getEarliestPickupDateTime(items);

  for (let i = 0; i < maxDaysToCheck; i++) {
    const date = addDays(earliest, i);
    const dateStr = formatDateInputValue(date);
    const slots = getAvailableSlotsForDate(dateStr, items);

    if (slots.length > 0) {
      return {
        date,
        dateStr,
        slots,
        firstSlot: slots[0],
      };
    }
  }

  return null;
}
